import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '../../../app.config';
import { BloqueioRodoviario, ListaPaginada } from '../../../model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BloqueioService {

  constructor(
    private http: HttpClient
  ) { }

  get(id: number): Observable<ListaPaginada<BloqueioRodoviario>> {
    return this.http.get<ListaPaginada<BloqueioRodoviario>>(`${API}/api/bloqueiorodoviario/${id}`);
  }

  post(bloqueio: BloqueioRodoviario): Observable<BloqueioRodoviario> {
    return this.http.post<BloqueioRodoviario>(`${API}/api/bloqueiorodoviario`, bloqueio);
  }

  put(bloqueio: BloqueioRodoviario): Observable<BloqueioRodoviario> {
    return this.http.put<BloqueioRodoviario>(`${API}/api/bloqueiorodoviario/${bloqueio.Id}`, bloqueio);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${API}/api/bloqueiorodoviario/${id}`);
  }
}
